// This file is auto-generated by @hey-api/openapi-ts

import type { Client, ClientMeta, Options as Options2, RequestResult, TDataShape } from './client';
import { client } from './client.gen';
import type { AiControllerCoachThreadByIdData, AiControllerCoachThreadByIdErrors, AiControllerCoachThreadByIdResponses, AiControllerCoachThreadsData, AiControllerCoachThreadsResponses, AiControllerCreateCoachThreadData, AiControllerCreateCoachThreadResponses, AiControllerDeleteCoachThreadData, AiControllerDeleteCoachThreadErrors, AiControllerDeleteCoachThreadResponses, AiControllerReportThreadVoiceTurnsData, AiControllerReportThreadVoiceTurnsErrors, AiControllerReportThreadVoiceTurnsResponses, AiControllerTranscribeData, AiControllerTranscribeResponses, AiControllerUpdateCoachThreadData, AiControllerUpdateCoachThreadResponses, AnalyticsControllerDimensionsData, AnalyticsControllerDimensionsResponses, AnalyticsControllerOverviewData, AnalyticsControllerOverviewErrors, AnalyticsControllerOverviewResponses, AnalyticsControllerTrainingsPerDayData, AnalyticsControllerTrainingsPerDayResponses, AuswertungControllerBearbeitungsstatusData, AuswertungControllerBearbeitungsstatusErrors, AuswertungControllerBearbeitungsstatusResponses, AuswertungControllerExportData, AuswertungControllerExportErrors, AuswertungControllerExportResponses, AuswertungControllerPruefungData, AuswertungControllerPruefungErrors, AuswertungControllerPruefungResponses, AuthControllerAbilityData, AuthControllerAbilityErrors, AuthControllerAbilityResponses, AuthControllerChangePasswordData, AuthControllerChangePasswordResponses, AuthControllerCompleteTourData, AuthControllerCompleteTourResponses, AuthControllerConsentData, AuthControllerConsentResponses, AuthControllerLogoutData, AuthControllerLogoutResponses, AuthControllerMagicLinkData, AuthControllerMagicLinkResponses, AuthControllerMeData, AuthControllerMeErrors, AuthControllerMeResponses, AuthControllerPasswordData, AuthControllerPasswordErrors, AuthControllerPasswordResponses, AuthControllerUpdateProfileData, AuthControllerUpdateProfileResponses, AuthControllerVerifyData, AuthControllerVerifyErrors, AuthControllerVerifyResponses, BereichFreigabeControllerEigeneData, BereichFreigabeControllerEigeneResponses, BereichFreigabeControllerListData, BereichFreigabeControllerListErrors, BereichFreigabeControllerListResponses, BereichFreigabeControllerSetData, BereichFreigabeControllerSetErrors, BereichFreigabeControllerSetResponses, ContentControllerCoachStylesData, ContentControllerCoachStylesResponses, ContentControllerPersonasData, ContentControllerPersonasResponses, ContentControllerRemoveCoachStyleData, ContentControllerRemoveCoachStyleResponses, ContentControllerRemovePersonaData, ContentControllerRemovePersonaResponses, ContentControllerUpsertCoachStyleData, ContentControllerUpsertCoachStyleResponses, ContentControllerUpsertPersonaData, ContentControllerUpsertPersonaErrors, ContentControllerUpsertPersonaResponses, EinheitFreigabeControllerEigeneData, EinheitFreigabeControllerEigeneResponses, EinheitFreigabeControllerListData, EinheitFreigabeControllerListErrors, EinheitFreigabeControllerListResponses, EinheitFreigabeControllerSetData, EinheitFreigabeControllerSetErrors, EinheitFreigabeControllerSetResponses, HealthControllerCheckData, HealthControllerCheckResponses, HealthControllerPingData, HealthControllerPingResponses, LearningEssenceControllerGetData, LearningEssenceControllerGetResponses, LearningEssenceControllerRemoveData, LearningEssenceControllerRemoveErrors, LearningEssenceControllerRemoveResponses, LearningEssenceControllerSkipData, LearningEssenceControllerSkipErrors, LearningEssenceControllerSkipResponses, LearningEssenceControllerStartData, LearningEssenceControllerStartResponses, PersonalPersonasControllerArchiveData, PersonalPersonasControllerArchiveResponses, PersonalPersonasControllerCreateData, PersonalPersonasControllerCreateResponses, PersonalPersonasControllerUpdateData, PersonalPersonasControllerUpdateResponses, ProcessRunControllerAdvanceData, ProcessRunControllerAdvanceResponses, ProcessRunControllerAvToolData, ProcessRunControllerAvToolResponses, ProcessRunControllerCreateData, ProcessRunControllerCreateResponses, ProcessRunControllerDebriefData, ProcessRunControllerDebriefResponses, ProcessRunControllerGetData, ProcessRunControllerGetErrors, ProcessRunControllerGetResponses, ProcessRunControllerListData, ProcessRunControllerListResponses, ProcessRunControllerLoesungData, ProcessRunControllerLoesungResponses, ProcessRunControllerNachbereitungData, ProcessRunControllerNachbereitungResponses, ProcessRunControllerPreparationData, ProcessRunControllerPreparationResponses, ProcessRunControllerReportVoiceTurnsData, ProcessRunControllerReportVoiceTurnsResponses, ProduktFreigabeControllerEigeneData, ProduktFreigabeControllerEigeneResponses, ProduktFreigabeControllerListData, ProduktFreigabeControllerListErrors, ProduktFreigabeControllerListResponses, ProduktFreigabeControllerSetData, ProduktFreigabeControllerSetErrors, ProduktFreigabeControllerSetResponses, PruefungControllerAntwortenData, PruefungControllerAntwortenErrors, PruefungControllerAntwortenResponses, PruefungControllerAuswertungenData, PruefungControllerAuswertungenErrors, PruefungControllerAuswertungenResponses, PruefungControllerLernfelderData, PruefungControllerLernfelderResponses, PruefungControllerLernstandAbrufenData, PruefungControllerLernstandAbrufenResponses, PruefungControllerSetzeTerminData, PruefungControllerSetzeTerminResponses, PruefungControllerVerlaengereZielData, PruefungControllerVerlaengereZielErrors, PruefungControllerVerlaengereZielResponses, PruefungControllerZuruecksetzenData, PruefungControllerZuruecksetzenResponses, ReflectionControllerAdvanceData, ReflectionControllerAdvanceErrors, ReflectionControllerAdvanceResponses, ReflectionControllerGetData, ReflectionControllerGetErrors, ReflectionControllerGetResponses, ReflectionControllerRemoveData, ReflectionControllerRemoveErrors, ReflectionControllerRemoveResponses, SessionsControllerAppendMessagesData, SessionsControllerAppendMessagesResponses, SessionsControllerCompleteData, SessionsControllerCompleteResponses, SessionsControllerCreateData, SessionsControllerCreateErrors, SessionsControllerCreateResponses, SessionsControllerGenerateFeedbackData, SessionsControllerGenerateFeedbackErrors, SessionsControllerGenerateFeedbackResponses, SessionsControllerGetData, SessionsControllerGetErrors, SessionsControllerGetResponses, SessionsControllerHeartbeatData, SessionsControllerHeartbeatResponses, SessionsControllerListData, SessionsControllerListResponses, SessionsControllerRateFeedbackData, SessionsControllerRateFeedbackResponses, SessionsControllerRemoveData, SessionsControllerRemoveResponses, SessionsControllerReportVoiceTurnsData, SessionsControllerReportVoiceTurnsResponses, TeamFreigabeControllerGetData, TeamFreigabeControllerGetErrors, TeamFreigabeControllerGetResponses, TeamFreigabeControllerSetBereichData, TeamFreigabeControllerSetBereichErrors, TeamFreigabeControllerSetBereichResponses, TeamFreigabeControllerSetEinheitData, TeamFreigabeControllerSetEinheitErrors, TeamFreigabeControllerSetEinheitResponses, TeamFreigabeControllerSetProduktData, TeamFreigabeControllerSetProduktErrors, TeamFreigabeControllerSetProduktResponses, TeamsControllerCreateData, TeamsControllerCreateErrors, TeamsControllerCreateResponses, TeamsControllerListData, TeamsControllerListResponses, TeamsControllerRemoveData, TeamsControllerRemoveErrors, TeamsControllerRemoveResponses, TeamsControllerSetMembersData, TeamsControllerSetMembersErrors, TeamsControllerSetMembersResponses, TeamsControllerUpdateData, TeamsControllerUpdateErrors, TeamsControllerUpdateResponses, TenantsControllerAuditLogData, TenantsControllerAuditLogPageData, TenantsControllerAuditLogPageResponses, TenantsControllerAuditLogResponses, TenantsControllerCreateData, TenantsControllerCreateErrors, TenantsControllerCreateResponses, TenantsControllerGetData, TenantsControllerGetErrors, TenantsControllerGetResponses, TenantsControllerListData, TenantsControllerListResponses, TenantsControllerSetBausteineData, TenantsControllerSetBausteineErrors, TenantsControllerSetBausteineResponses, TenantsControllerSetEmailDomainsData, TenantsControllerSetEmailDomainsErrors, TenantsControllerSetEmailDomainsResponses, TenantsControllerSubprozessorenData, TenantsControllerSubprozessorenResponses, TenantsControllerUpdateData, TenantsControllerUpdateErrors, TenantsControllerUpdateResponses, TenantsControllerViewAsData, TenantsControllerViewAsErrors, TenantsControllerViewAsResponses, UsersControllerEntsperrenData, UsersControllerEntsperrenErrors, UsersControllerEntsperrenResponses, UsersControllerIssueOneTimePasswordData, UsersControllerIssueOneTimePasswordErrors, UsersControllerIssueOneTimePasswordResponses, UsersControllerListData, UsersControllerListErrors, UsersControllerListResponses, UsersControllerRemoveData, UsersControllerRemoveErrors, UsersControllerRemoveResponses, UsersControllerSperrenData, UsersControllerSperrenErrors, UsersControllerSperrenResponses, UsersControllerUpsertData, UsersControllerUpsertErrors, UsersControllerUpsertResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

/**
 * Erreichbarkeit und Datenbankverbindung
 *
 * Wird vom Container-Healthcheck genutzt.
 */
export const healthControllerCheck = <ThrowOnError extends boolean = false>(options?: Options<HealthControllerCheckData, ThrowOnError>): RequestResult<HealthControllerCheckResponses, unknown, ThrowOnError> => (options?.client ?? client).get<HealthControllerCheckResponses, unknown, ThrowOnError>({ url: '/api/health', ...options });

/**
 * Reine Erreichbarkeit, ohne Datenbank
 *
 * Für externes Monitoring (Uptime Kuma). Bewusst ohne Datenbankabfrage, damit der Monitor-Intervall keine Last erzeugt und ein Datenbankausfall vom Prozessausfall unterscheidbar bleibt (/api/health vs. /api/health/ping).
 */
export const healthControllerPing = <ThrowOnError extends boolean = false>(options?: Options<HealthControllerPingData, ThrowOnError>): RequestResult<HealthControllerPingResponses, unknown, ThrowOnError> => (options?.client ?? client).get<HealthControllerPingResponses, unknown, ThrowOnError>({ url: '/api/health/ping', ...options });

/**
 * Anmeldelink anfordern
 *
 * Antwortet immer gleich, unabhängig davon, ob die Adresse existiert. Sonst würde die Anmeldemaske gültige Mailadressen preisgeben.
 */
export const authControllerMagicLink = <ThrowOnError extends boolean = false>(options: Options<AuthControllerMagicLinkData, ThrowOnError>): RequestResult<AuthControllerMagicLinkResponses, unknown, ThrowOnError> => (options.client ?? client).post<AuthControllerMagicLinkResponses, unknown, ThrowOnError>({
    url: '/api/auth/magic-link',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Anmeldelink einlösen
 */
export const authControllerVerify = <ThrowOnError extends boolean = false>(options: Options<AuthControllerVerifyData, ThrowOnError>): RequestResult<AuthControllerVerifyResponses, AuthControllerVerifyErrors, ThrowOnError> => (options.client ?? client).post<AuthControllerVerifyResponses, AuthControllerVerifyErrors, ThrowOnError>({
    url: '/api/auth/verify',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Anmeldung mit Einmal-Passwort
 *
 * Rückfallebene, wenn der Mailfilter einer Sparkasse den Anmeldelink verschluckt. Kein gleichwertiger zweiter Weg.
 */
export const authControllerPassword = <ThrowOnError extends boolean = false>(options: Options<AuthControllerPasswordData, ThrowOnError>): RequestResult<AuthControllerPasswordResponses, AuthControllerPasswordErrors, ThrowOnError> => (options.client ?? client).post<AuthControllerPasswordResponses, AuthControllerPasswordErrors, ThrowOnError>({
    url: '/api/auth/password',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Angemeldeter Nutzer
 */
export const authControllerMe = <ThrowOnError extends boolean = false>(options?: Options<AuthControllerMeData, ThrowOnError>): RequestResult<AuthControllerMeResponses, AuthControllerMeErrors, ThrowOnError> => (options?.client ?? client).get<AuthControllerMeResponses, AuthControllerMeErrors, ThrowOnError>({ url: '/api/auth/me', ...options });

/**
 * Berechtigungen des angemeldeten Nutzers
 *
 * Die CASL-Regeln, aus denen die Oberfläche ableitet, was sie anzeigt. Sie steuern nur die Darstellung; jede Anfrage wird serverseitig erneut geprüft. Berücksichtigt einen Wechsel in einen Mandanten.
 */
export const authControllerAbility = <ThrowOnError extends boolean = false>(options?: Options<AuthControllerAbilityData, ThrowOnError>): RequestResult<AuthControllerAbilityResponses, AuthControllerAbilityErrors, ThrowOnError> => (options?.client ?? client).get<AuthControllerAbilityResponses, AuthControllerAbilityErrors, ThrowOnError>({ url: '/api/auth/ability', ...options });

/**
 * Einwilligung bestätigen
 *
 * Beim ersten Login. Vorher wird kein Gespräch gespeichert, das der Nutzer nicht eingeordnet hat.
 */
export const authControllerConsent = <ThrowOnError extends boolean = false>(options?: Options<AuthControllerConsentData, ThrowOnError>): RequestResult<AuthControllerConsentResponses, unknown, ThrowOnError> => (options?.client ?? client).post<AuthControllerConsentResponses, unknown, ThrowOnError>({ url: '/api/auth/consent', ...options });

/**
 * Ein Häppchen des Rundgangs abschließen
 *
 * Der Rundgang ist in drei Häppchen geteilt: Startseite, Gesprächstraining und Chat. Das genannte wurde durchlaufen oder übersprungen; beides zählt als beantwortet, danach startet es nicht mehr von allein.
 */
export const authControllerCompleteTour = <ThrowOnError extends boolean = false>(options: Options<AuthControllerCompleteTourData, ThrowOnError>): RequestResult<AuthControllerCompleteTourResponses, unknown, ThrowOnError> => (options.client ?? client).post<AuthControllerCompleteTourResponses, unknown, ThrowOnError>({
    url: '/api/auth/tour',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Name und Coach setzen
 *
 * Beim ersten Login über das Onboarding, später über die Einstellungen. Der Magic-Link-Login kennt nur die E-Mail, der Anzeigename kommt hier her.
 */
export const authControllerUpdateProfile = <ThrowOnError extends boolean = false>(options: Options<AuthControllerUpdateProfileData, ThrowOnError>): RequestResult<AuthControllerUpdateProfileResponses, unknown, ThrowOnError> => (options.client ?? client).post<AuthControllerUpdateProfileResponses, unknown, ThrowOnError>({
    url: '/api/auth/profile',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Passwort ändern
 */
export const authControllerChangePassword = <ThrowOnError extends boolean = false>(options: Options<AuthControllerChangePasswordData, ThrowOnError>): RequestResult<AuthControllerChangePasswordResponses, unknown, ThrowOnError> => (options.client ?? client).post<AuthControllerChangePasswordResponses, unknown, ThrowOnError>({
    url: '/api/auth/change-password',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Abmelden
 */
export const authControllerLogout = <ThrowOnError extends boolean = false>(options?: Options<AuthControllerLogoutData, ThrowOnError>): RequestResult<AuthControllerLogoutResponses, unknown, ThrowOnError> => (options?.client ?? client).post<AuthControllerLogoutResponses, unknown, ThrowOnError>({ url: '/api/auth/logout', ...options });

/**
 * Nutzer des eigenen Mandanten
 *
 * Nie der gesamte Bestand, immer auf den Mandanten gescoped. Die Plattformrolle kann mit `tenantId` gezielt eine Sparkasse abfragen, ohne die ganze Sitzung in sie zu wechseln.
 */
export const usersControllerList = <ThrowOnError extends boolean = false>(options?: Options<UsersControllerListData, ThrowOnError>): RequestResult<UsersControllerListResponses, UsersControllerListErrors, ThrowOnError> => (options?.client ?? client).get<UsersControllerListResponses, UsersControllerListErrors, ThrowOnError>({ url: '/api/users', ...options });

/**
 * Nutzer anlegen oder ändern
 *
 * Neue Nutzer starten im Status eingeladen. Die Plattformrolle kann den Mandanten im Feld `tenantId` mitgeben.
 */
export const usersControllerUpsert = <ThrowOnError extends boolean = false>(options: Options<UsersControllerUpsertData, ThrowOnError>): RequestResult<UsersControllerUpsertResponses, UsersControllerUpsertErrors, ThrowOnError> => (options.client ?? client).post<UsersControllerUpsertResponses, UsersControllerUpsertErrors, ThrowOnError>({
    url: '/api/users',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Einmal-Passwort vergeben
 *
 * Rückfallebene, wenn der Mailfilter den Anmeldelink verschluckt. Das Passwort wird genau einmal ausgeliefert, in der Datenbank steht nur der Hash. Beim ersten Login muss es gewechselt werden. Ein neuer Aufruf ersetzt das vorherige Passwort. Mit `variant: "email"` wird statt eines zufälligen Passworts der Mailname plus fester Zusatz vergeben (`a.becker-start-2026`), damit es sich einer ganzen Gruppe mit einer Ansage mitteilen lässt. Dieses Passwort ist bis zum Wechsel erratbar.
 */
export const usersControllerIssueOneTimePassword = <ThrowOnError extends boolean = false>(options: Options<UsersControllerIssueOneTimePasswordData, ThrowOnError>): RequestResult<UsersControllerIssueOneTimePasswordResponses, UsersControllerIssueOneTimePasswordErrors, ThrowOnError> => (options.client ?? client).post<UsersControllerIssueOneTimePasswordResponses, UsersControllerIssueOneTimePasswordErrors, ThrowOnError>({
    url: '/api/users/{id}/one-time-password',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Nutzer sperren
 *
 * Bestehende Sitzungen werden sofort entzogen. Daten bleiben erhalten.
 */
export const usersControllerSperren = <ThrowOnError extends boolean = false>(options: Options<UsersControllerSperrenData, ThrowOnError>): RequestResult<UsersControllerSperrenResponses, UsersControllerSperrenErrors, ThrowOnError> => (options.client ?? client).post<UsersControllerSperrenResponses, UsersControllerSperrenErrors, ThrowOnError>({ url: '/api/users/{id}/sperren', ...options });

/**
 * Sperre aufheben
 *
 * Ein Konto, das sich nie angemeldet hat, kehrt in den Status eingeladen zurück, damit die Einwilligung beim ersten Login bleibt.
 */
export const usersControllerEntsperren = <ThrowOnError extends boolean = false>(options: Options<UsersControllerEntsperrenData, ThrowOnError>): RequestResult<UsersControllerEntsperrenResponses, UsersControllerEntsperrenErrors, ThrowOnError> => (options.client ?? client).post<UsersControllerEntsperrenResponses, UsersControllerEntsperrenErrors, ThrowOnError>({ url: '/api/users/{id}/entsperren', ...options });

/**
 * Nutzer löschen
 *
 * Nur für gesperrte Konten. Löscht das Konto mit allen Trainingsdaten endgültig, darunter Gespräche, Feedback, Prüfungsstand und Lernessenz. Kostenzeilen bleiben ohne Personenbezug erhalten.
 */
export const usersControllerRemove = <ThrowOnError extends boolean = false>(options: Options<UsersControllerRemoveData, ThrowOnError>): RequestResult<UsersControllerRemoveResponses, UsersControllerRemoveErrors, ThrowOnError> => (options.client ?? client).delete<UsersControllerRemoveResponses, UsersControllerRemoveErrors, ThrowOnError>({ url: '/api/users/{id}', ...options });

/**
 * Mandanten
 *
 * Nur die Plattformrolle sieht alle, sonst nur den eigenen.
 */
export const tenantsControllerList = <ThrowOnError extends boolean = false>(options?: Options<TenantsControllerListData, ThrowOnError>): RequestResult<TenantsControllerListResponses, unknown, ThrowOnError> => (options?.client ?? client).get<TenantsControllerListResponses, unknown, ThrowOnError>({ url: '/api/tenants', ...options });

/**
 * Mandanten anlegen
 *
 * Das Kürzel wird zur ID und ist danach nicht mehr änderbar. Neue Mandanten starten ohne Nutzer und ohne Sperren.
 */
export const tenantsControllerCreate = <ThrowOnError extends boolean = false>(options: Options<TenantsControllerCreateData, ThrowOnError>): RequestResult<TenantsControllerCreateResponses, TenantsControllerCreateErrors, ThrowOnError> => (options.client ?? client).post<TenantsControllerCreateResponses, TenantsControllerCreateErrors, ThrowOnError>({
    url: '/api/tenants',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Ein Mandant
 */
export const tenantsControllerGet = <ThrowOnError extends boolean = false>(options: Options<TenantsControllerGetData, ThrowOnError>): RequestResult<TenantsControllerGetResponses, TenantsControllerGetErrors, ThrowOnError> => (options.client ?? client).get<TenantsControllerGetResponses, TenantsControllerGetErrors, ThrowOnError>({ url: '/api/tenants/{id}', ...options });

/**
 * Mandanten ändern
 *
 * Name, Region, Status und Plätze. Gelöscht wird nicht, solange die Aufbewahrungsfristen offen sind; stattdessen wird pausiert.
 */
export const tenantsControllerUpdate = <ThrowOnError extends boolean = false>(options: Options<TenantsControllerUpdateData, ThrowOnError>): RequestResult<TenantsControllerUpdateResponses, TenantsControllerUpdateErrors, ThrowOnError> => (options.client ?? client).patch<TenantsControllerUpdateResponses, TenantsControllerUpdateErrors, ThrowOnError>({
    url: '/api/tenants/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * In einen Mandanten wechseln
 *
 * Hält im Protokoll fest, dass die Plattformrolle die Ansicht einer Sparkasse geöffnet hat. Der Wechsel selbst läuft über den Header `x-view-as-tenant`.
 */
export const tenantsControllerViewAs = <ThrowOnError extends boolean = false>(options: Options<TenantsControllerViewAsData, ThrowOnError>): RequestResult<TenantsControllerViewAsResponses, TenantsControllerViewAsErrors, ThrowOnError> => (options.client ?? client).post<TenantsControllerViewAsResponses, TenantsControllerViewAsErrors, ThrowOnError>({ url: '/api/tenants/{id}/view-as', ...options });

/**
 * E-Mail-Domains für die Selbstanmeldung setzen
 *
 * Wer sich mit einer passenden Adresse einen Anmeldelink schicken lässt, bekommt beim Einlösen automatisch ein Beraterkonto in dieser Sparkasse. Muster: `sparkasse-beispiel.de` oder `*.sparkasse-beispiel.de`. Eine Domain kann nur einer Sparkasse gehören.
 */
export const tenantsControllerSetEmailDomains = <ThrowOnError extends boolean = false>(options: Options<TenantsControllerSetEmailDomainsData, ThrowOnError>): RequestResult<TenantsControllerSetEmailDomainsResponses, TenantsControllerSetEmailDomainsErrors, ThrowOnError> => (options.client ?? client).put<TenantsControllerSetEmailDomainsResponses, TenantsControllerSetEmailDomainsErrors, ThrowOnError>({
    url: '/api/tenants/{id}/email-domains',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Bausteine einer Sparkasse festlegen
 *
 * Legt fest, womit die Sparkasse trainiert, etwa ob das Einkommensgutachten den Einkommensschutz (BU) enthält. Gilt für jeden neuen Durchlauf der Sparkasse; die Berater:innen wählen das nicht selbst.
 */
export const tenantsControllerSetBausteine = <ThrowOnError extends boolean = false>(options: Options<TenantsControllerSetBausteineData, ThrowOnError>): RequestResult<TenantsControllerSetBausteineResponses, TenantsControllerSetBausteineErrors, ThrowOnError> => (options.client ?? client).put<TenantsControllerSetBausteineResponses, TenantsControllerSetBausteineErrors, ThrowOnError>({
    url: '/api/tenants/{id}/bausteine',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Protokoll administrativer Vorgänge
 */
export const tenantsControllerAuditLog = <ThrowOnError extends boolean = false>(options?: Options<TenantsControllerAuditLogData, ThrowOnError>): RequestResult<TenantsControllerAuditLogResponses, unknown, ThrowOnError> => (options?.client ?? client).get<TenantsControllerAuditLogResponses, unknown, ThrowOnError>({ url: '/api/audit-log', ...options });

/**
 * Technisches Protokoll der Verwaltung
 *
 * Alle Mandanten, neueste zuerst. Filter nach Mandant, Aktion (Teiltext) und Zeitraum (ISO-Datum). Seitenweise über `cursor`.
 */
export const tenantsControllerAuditLogPage = <ThrowOnError extends boolean = false>(options?: Options<TenantsControllerAuditLogPageData, ThrowOnError>): RequestResult<TenantsControllerAuditLogPageResponses, unknown, ThrowOnError> => (options?.client ?? client).get<TenantsControllerAuditLogPageResponses, unknown, ThrowOnError>({ url: '/api/admin/audit-log', ...options });

/**
 * Subprozessoren
 *
 * Transparenzangabe gegenüber den Sparkassen. Bewusst ohne Anmeldung abrufbar, enthält keine personenbezogenen Daten.
 */
export const tenantsControllerSubprozessoren = <ThrowOnError extends boolean = false>(options?: Options<TenantsControllerSubprozessorenData, ThrowOnError>): RequestResult<TenantsControllerSubprozessorenResponses, unknown, ThrowOnError> => (options?.client ?? client).get<TenantsControllerSubprozessorenResponses, unknown, ThrowOnError>({ url: '/api/subprozessoren', ...options });

/**
 * Teams des eigenen Mandanten
 */
export const teamsControllerList = <ThrowOnError extends boolean = false>(options?: Options<TeamsControllerListData, ThrowOnError>): RequestResult<TeamsControllerListResponses, unknown, ThrowOnError> => (options?.client ?? client).get<TeamsControllerListResponses, unknown, ThrowOnError>({ url: '/api/teams', ...options });

/**
 * Pilotgruppe anlegen
 */
export const teamsControllerCreate = <ThrowOnError extends boolean = false>(options: Options<TeamsControllerCreateData, ThrowOnError>): RequestResult<TeamsControllerCreateResponses, TeamsControllerCreateErrors, ThrowOnError> => (options.client ?? client).post<TeamsControllerCreateResponses, TeamsControllerCreateErrors, ThrowOnError>({
    url: '/api/tenants/{id}/teams',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Pilotgruppe löschen
 *
 * Die Mitglieder bleiben im Mandanten, nur ohne Gruppe. Ihre Trainings bleiben unverändert. Abweichende Freischaltungen der Gruppe entfallen.
 */
export const teamsControllerRemove = <ThrowOnError extends boolean = false>(options: Options<TeamsControllerRemoveData, ThrowOnError>): RequestResult<TeamsControllerRemoveResponses, TeamsControllerRemoveErrors, ThrowOnError> => (options.client ?? client).delete<TeamsControllerRemoveResponses, TeamsControllerRemoveErrors, ThrowOnError>({ url: '/api/teams/{id}', ...options });

/**
 * Pilotgruppe ändern
 */
export const teamsControllerUpdate = <ThrowOnError extends boolean = false>(options: Options<TeamsControllerUpdateData, ThrowOnError>): RequestResult<TeamsControllerUpdateResponses, TeamsControllerUpdateErrors, ThrowOnError> => (options.client ?? client).patch<TeamsControllerUpdateResponses, TeamsControllerUpdateErrors, ThrowOnError>({
    url: '/api/teams/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Mitglieder einer Pilotgruppe hinzufügen oder entfernen
 *
 * Nur Konten desselben Mandanten. Wer bereits in einer anderen Gruppe ist, wechselt in diese. Jede Änderung wird protokolliert.
 */
export const teamsControllerSetMembers = <ThrowOnError extends boolean = false>(options: Options<TeamsControllerSetMembersData, ThrowOnError>): RequestResult<TeamsControllerSetMembersResponses, TeamsControllerSetMembersErrors, ThrowOnError> => (options.client ?? client).put<TeamsControllerSetMembersResponses, TeamsControllerSetMembersErrors, ThrowOnError>({
    url: '/api/teams/{id}/members',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Prüfungsvorbereitung je Mandant oder Pilotgruppe
 *
 * Ausschließlich Aggregate: Teilnehmende, Antworten und Quote richtig, gesamt und je Lernfeld. Unter fünf Personen werden keine Werte geliefert. Einzelergebnisse sind bewusst nicht abrufbar. Ein Coach sieht nur die eigene Pilotgruppe.
 */
export const auswertungControllerPruefung = <ThrowOnError extends boolean = false>(options: Options<AuswertungControllerPruefungData, ThrowOnError>): RequestResult<AuswertungControllerPruefungResponses, AuswertungControllerPruefungErrors, ThrowOnError> => (options.client ?? client).get<AuswertungControllerPruefungResponses, AuswertungControllerPruefungErrors, ThrowOnError>({ url: '/api/auswertung/pruefung', ...options });

/**
 * Bearbeitungsstatus je Mandant oder Pilotgruppe
 *
 * Je Trainingseinheit, wie viele Personen begonnen und abgeschlossen haben. Keine Namen, unter fünf Personen keine Werte. Ein Coach sieht nur die eigene Pilotgruppe.
 */
export const auswertungControllerBearbeitungsstatus = <ThrowOnError extends boolean = false>(options: Options<AuswertungControllerBearbeitungsstatusData, ThrowOnError>): RequestResult<AuswertungControllerBearbeitungsstatusResponses, AuswertungControllerBearbeitungsstatusErrors, ThrowOnError> => (options.client ?? client).get<AuswertungControllerBearbeitungsstatusResponses, AuswertungControllerBearbeitungsstatusErrors, ThrowOnError>({ url: '/api/auswertung/bearbeitungsstatus', ...options });

/**
 * Konsolidierte Ergebnisse eines Mandanten als CSV
 *
 * Dieselben Aggregate wie in der Verwaltung, für den Mandanten gesamt und je Pilotgruppe. Jeder Export wird protokolliert.
 */
export const auswertungControllerExport = <ThrowOnError extends boolean = false>(options: Options<AuswertungControllerExportData, ThrowOnError>): RequestResult<AuswertungControllerExportResponses, AuswertungControllerExportErrors, ThrowOnError> => (options.client ?? client).get<AuswertungControllerExportResponses, AuswertungControllerExportErrors, ThrowOnError>({ url: '/api/auswertung/export', ...options });

/**
 * Freischaltung der Trainingseinheiten in der eigenen Sparkasse
 *
 * Je Trainingseinheit, ob sie offen, gesperrt oder für einen Zeitpunkt geplant ist. Ein geplanter Termin gilt ab dem angegebenen Zeitpunkt ohne weiteres Zutun als offen.
 */
export const einheitFreigabeControllerEigene = <ThrowOnError extends boolean = false>(options?: Options<EinheitFreigabeControllerEigeneData, ThrowOnError>): RequestResult<EinheitFreigabeControllerEigeneResponses, unknown, ThrowOnError> => (options?.client ?? client).get<EinheitFreigabeControllerEigeneResponses, unknown, ThrowOnError>({ url: '/api/einheit-freigaben', ...options });

/**
 * Freischaltplan einer Sparkasse
 *
 * Die Führungskraft sieht nur den Plan der eigenen Sparkasse.
 */
export const einheitFreigabeControllerList = <ThrowOnError extends boolean = false>(options: Options<EinheitFreigabeControllerListData, ThrowOnError>): RequestResult<EinheitFreigabeControllerListResponses, EinheitFreigabeControllerListErrors, ThrowOnError> => (options.client ?? client).get<EinheitFreigabeControllerListResponses, EinheitFreigabeControllerListErrors, ThrowOnError>({ url: '/api/tenants/{id}/einheit-freigaben', ...options });

/**
 * Trainingseinheit freischalten, sperren oder planen
 *
 * `offen` schaltet sofort frei, `gesperrt` sperrt bis auf Weiteres, `geplant` sperrt bis zum angegebenen Zeitpunkt. Laufende Gesprächstrainings sind nicht betroffen. Jede Änderung wird protokolliert.
 */
export const einheitFreigabeControllerSet = <ThrowOnError extends boolean = false>(options: Options<EinheitFreigabeControllerSetData, ThrowOnError>): RequestResult<EinheitFreigabeControllerSetResponses, EinheitFreigabeControllerSetErrors, ThrowOnError> => (options.client ?? client).put<EinheitFreigabeControllerSetResponses, EinheitFreigabeControllerSetErrors, ThrowOnError>({
    url: '/api/tenants/{id}/einheit-freigaben/{einheit}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Freischaltung der Bereiche in der eigenen Sparkasse
 *
 * Je Bereich (Terminvorbereitung, Gesprächstraining, Produkttraining, Prüfungsvorbereitung), ob er offen, gesperrt oder für einen Zeitpunkt geplant ist.
 */
export const bereichFreigabeControllerEigene = <ThrowOnError extends boolean = false>(options?: Options<BereichFreigabeControllerEigeneData, ThrowOnError>): RequestResult<BereichFreigabeControllerEigeneResponses, unknown, ThrowOnError> => (options?.client ?? client).get<BereichFreigabeControllerEigeneResponses, unknown, ThrowOnError>({ url: '/api/bereich-freigaben', ...options });

/**
 * Freischaltplan der Bereiche einer Sparkasse
 *
 * Die Führungskraft sieht nur den Plan der eigenen Sparkasse.
 */
export const bereichFreigabeControllerList = <ThrowOnError extends boolean = false>(options: Options<BereichFreigabeControllerListData, ThrowOnError>): RequestResult<BereichFreigabeControllerListResponses, BereichFreigabeControllerListErrors, ThrowOnError> => (options.client ?? client).get<BereichFreigabeControllerListResponses, BereichFreigabeControllerListErrors, ThrowOnError>({ url: '/api/tenants/{id}/bereich-freigaben', ...options });

/**
 * Bereich freischalten, sperren oder planen
 *
 * Gesperrt wird nur das Starten von Neuem. Laufende Gesprächstrainings, Auswertungen und bestehende Gespräche bleiben erreichbar. Jede Änderung wird protokolliert.
 */
export const bereichFreigabeControllerSet = <ThrowOnError extends boolean = false>(options: Options<BereichFreigabeControllerSetData, ThrowOnError>): RequestResult<BereichFreigabeControllerSetResponses, BereichFreigabeControllerSetErrors, ThrowOnError> => (options.client ?? client).put<BereichFreigabeControllerSetResponses, BereichFreigabeControllerSetErrors, ThrowOnError>({
    url: '/api/tenants/{id}/bereich-freigaben/{bereich}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Freischaltung der Produkte in der eigenen Sparkasse
 *
 * Je Produkt im Produkttraining, ob es offen, gesperrt oder für einen Zeitpunkt geplant ist. Produkte ohne hinterlegte Inhalte sind immer gesperrt.
 */
export const produktFreigabeControllerEigene = <ThrowOnError extends boolean = false>(options?: Options<ProduktFreigabeControllerEigeneData, ThrowOnError>): RequestResult<ProduktFreigabeControllerEigeneResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ProduktFreigabeControllerEigeneResponses, unknown, ThrowOnError>({ url: '/api/produkt-freigaben', ...options });

/**
 * Freischaltplan der Produkte einer Sparkasse
 *
 * Die Führungskraft sieht nur den Plan der eigenen Sparkasse.
 */
export const produktFreigabeControllerList = <ThrowOnError extends boolean = false>(options: Options<ProduktFreigabeControllerListData, ThrowOnError>): RequestResult<ProduktFreigabeControllerListResponses, ProduktFreigabeControllerListErrors, ThrowOnError> => (options.client ?? client).get<ProduktFreigabeControllerListResponses, ProduktFreigabeControllerListErrors, ThrowOnError>({ url: '/api/tenants/{id}/produkt-freigaben', ...options });

/**
 * Produkt freischalten, sperren oder planen
 *
 * Gesperrt wird nur das Starten eines Produkttrainings. Bestehende Gespräche bleiben erreichbar. Jede Änderung wird protokolliert.
 */
export const produktFreigabeControllerSet = <ThrowOnError extends boolean = false>(options: Options<ProduktFreigabeControllerSetData, ThrowOnError>): RequestResult<ProduktFreigabeControllerSetResponses, ProduktFreigabeControllerSetErrors, ThrowOnError> => (options.client ?? client).put<ProduktFreigabeControllerSetResponses, ProduktFreigabeControllerSetErrors, ThrowOnError>({
    url: '/api/tenants/{id}/produkt-freigaben/{produkt}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Freischaltung einer Pilotgruppe
 *
 * Je Bereich, Trainingseinheit und Produkt der Stand, der für die Mitglieder gilt, daneben der Stand des Mandanten. `quelle` sagt, ob die Gruppe ihn überschreibt.
 */
export const teamFreigabeControllerGet = <ThrowOnError extends boolean = false>(options: Options<TeamFreigabeControllerGetData, ThrowOnError>): RequestResult<TeamFreigabeControllerGetResponses, TeamFreigabeControllerGetErrors, ThrowOnError> => (options.client ?? client).get<TeamFreigabeControllerGetResponses, TeamFreigabeControllerGetErrors, ThrowOnError>({ url: '/api/tenants/{id}/teams/{teamId}/freigaben', ...options });

/**
 * Bereich für eine Pilotgruppe freischalten oder sperren
 *
 * `wie_mandant` hebt die Abweichung auf, die Gruppe folgt dann wieder dem Mandanten. `offen` schaltet auch frei, was der Mandant gesperrt hält. Jede Änderung wird protokolliert.
 */
export const teamFreigabeControllerSetBereich = <ThrowOnError extends boolean = false>(options: Options<TeamFreigabeControllerSetBereichData, ThrowOnError>): RequestResult<TeamFreigabeControllerSetBereichResponses, TeamFreigabeControllerSetBereichErrors, ThrowOnError> => (options.client ?? client).put<TeamFreigabeControllerSetBereichResponses, TeamFreigabeControllerSetBereichErrors, ThrowOnError>({
    url: '/api/tenants/{id}/teams/{teamId}/bereich-freigaben/{bereich}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Trainingseinheit für eine Pilotgruppe freischalten oder sperren
 *
 * Wie bei den Bereichen. Einheiten ohne Inhalte bleiben für alle gesperrt.
 */
export const teamFreigabeControllerSetEinheit = <ThrowOnError extends boolean = false>(options: Options<TeamFreigabeControllerSetEinheitData, ThrowOnError>): RequestResult<TeamFreigabeControllerSetEinheitResponses, TeamFreigabeControllerSetEinheitErrors, ThrowOnError> => (options.client ?? client).put<TeamFreigabeControllerSetEinheitResponses, TeamFreigabeControllerSetEinheitErrors, ThrowOnError>({
    url: '/api/tenants/{id}/teams/{teamId}/einheit-freigaben/{einheit}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Produkt für eine Pilotgruppe freischalten oder sperren
 *
 * Wie bei den Bereichen. Produkte ohne Inhalte bleiben für alle gesperrt.
 */
export const teamFreigabeControllerSetProdukt = <ThrowOnError extends boolean = false>(options: Options<TeamFreigabeControllerSetProduktData, ThrowOnError>): RequestResult<TeamFreigabeControllerSetProduktResponses, TeamFreigabeControllerSetProduktErrors, ThrowOnError> => (options.client ?? client).put<TeamFreigabeControllerSetProduktResponses, TeamFreigabeControllerSetProduktErrors, ThrowOnError>({
    url: '/api/tenants/{id}/teams/{teamId}/produkt-freigaben/{produkt}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Personas
 *
 * Globale Vorlagen plus die eigenen des Mandanten. Fremde Mandanten sind nicht enthalten.
 */
export const contentControllerPersonas = <ThrowOnError extends boolean = false>(options?: Options<ContentControllerPersonasData, ThrowOnError>): RequestResult<ContentControllerPersonasResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ContentControllerPersonasResponses, unknown, ThrowOnError>({ url: '/api/personas', ...options });

/**
 * Persona anlegen oder ändern
 *
 * Beim Bearbeiten einer globalen Vorlage entsteht automatisch eine mandantenspezifische Kopie, statt die Vorlage für alle zu verändern.
 */
export const contentControllerUpsertPersona = <ThrowOnError extends boolean = false>(options: Options<ContentControllerUpsertPersonaData, ThrowOnError>): RequestResult<ContentControllerUpsertPersonaResponses, ContentControllerUpsertPersonaErrors, ThrowOnError> => (options.client ?? client).post<ContentControllerUpsertPersonaResponses, ContentControllerUpsertPersonaErrors, ThrowOnError>({
    url: '/api/personas',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Persona archivieren
 *
 * Archiviert statt löscht, damit bestehende Gespräche ihre Referenz behalten.
 */
export const contentControllerRemovePersona = <ThrowOnError extends boolean = false>(options: Options<ContentControllerRemovePersonaData, ThrowOnError>): RequestResult<ContentControllerRemovePersonaResponses, unknown, ThrowOnError> => (options.client ?? client).delete<ContentControllerRemovePersonaResponses, unknown, ThrowOnError>({ url: '/api/personas/{id}', ...options });

/**
 * Coach-Stile
 */
export const contentControllerCoachStyles = <ThrowOnError extends boolean = false>(options?: Options<ContentControllerCoachStylesData, ThrowOnError>): RequestResult<ContentControllerCoachStylesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ContentControllerCoachStylesResponses, unknown, ThrowOnError>({ url: '/api/coach-styles', ...options });

/**
 * Coach-Stil anlegen oder ändern
 */
export const contentControllerUpsertCoachStyle = <ThrowOnError extends boolean = false>(options: Options<ContentControllerUpsertCoachStyleData, ThrowOnError>): RequestResult<ContentControllerUpsertCoachStyleResponses, unknown, ThrowOnError> => (options.client ?? client).post<ContentControllerUpsertCoachStyleResponses, unknown, ThrowOnError>({
    url: '/api/coach-styles',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Coach-Stil deaktivieren
 */
export const contentControllerRemoveCoachStyle = <ThrowOnError extends boolean = false>(options: Options<ContentControllerRemoveCoachStyleData, ThrowOnError>): RequestResult<ContentControllerRemoveCoachStyleResponses, unknown, ThrowOnError> => (options.client ?? client).delete<ContentControllerRemoveCoachStyleResponses, unknown, ThrowOnError>({ url: '/api/coach-styles/{id}', ...options });

/**
 * Privaten KI-Kunden erstellen
 */
export const personalPersonasControllerCreate = <ThrowOnError extends boolean = false>(options: Options<PersonalPersonasControllerCreateData, ThrowOnError>): RequestResult<PersonalPersonasControllerCreateResponses, unknown, ThrowOnError> => (options.client ?? client).post<PersonalPersonasControllerCreateResponses, unknown, ThrowOnError>({
    url: '/api/my-personas',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Privaten KI-Kunden aus der Auswahl entfernen; Trainings bleiben erhalten
 */
export const personalPersonasControllerArchive = <ThrowOnError extends boolean = false>(options: Options<PersonalPersonasControllerArchiveData, ThrowOnError>): RequestResult<PersonalPersonasControllerArchiveResponses, unknown, ThrowOnError> => (options.client ?? client).delete<PersonalPersonasControllerArchiveResponses, unknown, ThrowOnError>({ url: '/api/my-personas/{id}', ...options });

/**
 * Privaten KI-Kunden als neue Version speichern
 */
export const personalPersonasControllerUpdate = <ThrowOnError extends boolean = false>(options: Options<PersonalPersonasControllerUpdateData, ThrowOnError>): RequestResult<PersonalPersonasControllerUpdateResponses, unknown, ThrowOnError> => (options.client ?? client).put<PersonalPersonasControllerUpdateResponses, unknown, ThrowOnError>({
    url: '/api/my-personas/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Eigene Trainingsgespräche
 *
 * Liefert ausschliesslich die Gespräche des angemeldeten Nutzers. Coaches und Führungskräfte sehen hier nichts von ihren Teams.
 */
export const sessionsControllerList = <ThrowOnError extends boolean = false>(options?: Options<SessionsControllerListData, ThrowOnError>): RequestResult<SessionsControllerListResponses, unknown, ThrowOnError> => (options?.client ?? client).get<SessionsControllerListResponses, unknown, ThrowOnError>({ url: '/api/sessions', ...options });

/**
 * Trainingsgespräch starten
 */
export const sessionsControllerCreate = <ThrowOnError extends boolean = false>(options: Options<SessionsControllerCreateData, ThrowOnError>): RequestResult<SessionsControllerCreateResponses, SessionsControllerCreateErrors, ThrowOnError> => (options.client ?? client).post<SessionsControllerCreateResponses, SessionsControllerCreateErrors, ThrowOnError>({
    url: '/api/sessions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Eigenes Gespräch löschen
 *
 * Soft Delete. Hält die noch offene Entscheidung über Löschfristen offen, gibt dem Berater aber Kontrolle über die eigenen Gespräche.
 */
export const sessionsControllerRemove = <ThrowOnError extends boolean = false>(options: Options<SessionsControllerRemoveData, ThrowOnError>): RequestResult<SessionsControllerRemoveResponses, unknown, ThrowOnError> => (options.client ?? client).delete<SessionsControllerRemoveResponses, unknown, ThrowOnError>({ url: '/api/sessions/{id}', ...options });

/**
 * Ein eigenes Trainingsgespräch
 */
export const sessionsControllerGet = <ThrowOnError extends boolean = false>(options: Options<SessionsControllerGetData, ThrowOnError>): RequestResult<SessionsControllerGetResponses, SessionsControllerGetErrors, ThrowOnError> => (options.client ?? client).get<SessionsControllerGetResponses, SessionsControllerGetErrors, ThrowOnError>({ url: '/api/sessions/{id}', ...options });

/**
 * Nachrichten anhängen
 */
export const sessionsControllerAppendMessages = <ThrowOnError extends boolean = false>(options: Options<SessionsControllerAppendMessagesData, ThrowOnError>): RequestResult<SessionsControllerAppendMessagesResponses, unknown, ThrowOnError> => (options.client ?? client).post<SessionsControllerAppendMessagesResponses, unknown, ThrowOnError>({
    url: '/api/sessions/{id}/messages',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Sprachgespräch nachmelden
 *
 * Seit dem 12.08.2026 schreibt der Server die Beiträge eines Anrufs selbst, weil die Sprachverbindung über ihn läuft. Diese Route bleibt als Nachmeldeweg bestehen und ist bewusst idempotenzfrei: sie hängt an, was sie bekommt.
 */
export const sessionsControllerReportVoiceTurns = <ThrowOnError extends boolean = false>(options: Options<SessionsControllerReportVoiceTurnsData, ThrowOnError>): RequestResult<SessionsControllerReportVoiceTurnsResponses, unknown, ThrowOnError> => (options.client ?? client).post<SessionsControllerReportVoiceTurnsResponses, unknown, ThrowOnError>({
    url: '/api/sessions/{id}/voice-turns',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * IDD-Zeitstand melden
 *
 * Der Client zählt aktive Zeit, der Server verankert sie mit einem Zeitstempel. Gemeldete Zeit kann nie unter den erfassten Stand fallen.
 */
export const sessionsControllerHeartbeat = <ThrowOnError extends boolean = false>(options: Options<SessionsControllerHeartbeatData, ThrowOnError>): RequestResult<SessionsControllerHeartbeatResponses, unknown, ThrowOnError> => (options.client ?? client).post<SessionsControllerHeartbeatResponses, unknown, ThrowOnError>({
    url: '/api/sessions/{id}/heartbeat',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Gespräch abschliessen
 */
export const sessionsControllerComplete = <ThrowOnError extends boolean = false>(options: Options<SessionsControllerCompleteData, ThrowOnError>): RequestResult<SessionsControllerCompleteResponses, unknown, ThrowOnError> => (options.client ?? client).post<SessionsControllerCompleteResponses, unknown, ThrowOnError>({
    url: '/api/sessions/{id}/complete',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Feedback erzeugen
 *
 * Idempotent: liegt bereits ein Feedback vor, wird es zurückgegeben statt neu erzeugt. Sonst würde jede Anzeige erneut Kosten auslösen.
 */
export const sessionsControllerGenerateFeedback = <ThrowOnError extends boolean = false>(options: Options<SessionsControllerGenerateFeedbackData, ThrowOnError>): RequestResult<SessionsControllerGenerateFeedbackResponses, SessionsControllerGenerateFeedbackErrors, ThrowOnError> => (options.client ?? client).post<SessionsControllerGenerateFeedbackResponses, SessionsControllerGenerateFeedbackErrors, ThrowOnError>({ url: '/api/sessions/{id}/feedback', ...options });

/**
 * KI-Rückmeldung bewerten
 *
 * Zentrale Akzeptanzmessung des Proof of Concept. Wiederholtes Senden überschreibt die vorherige Bewertung.
 */
export const sessionsControllerRateFeedback = <ThrowOnError extends boolean = false>(options: Options<SessionsControllerRateFeedbackData, ThrowOnError>): RequestResult<SessionsControllerRateFeedbackResponses, unknown, ThrowOnError> => (options.client ?? client).post<SessionsControllerRateFeedbackResponses, unknown, ThrowOnError>({
    url: '/api/sessions/{id}/feedback/rating',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Eigene Gespräche mit dem KI-Coach
 */
export const aiControllerCoachThreads = <ThrowOnError extends boolean = false>(options?: Options<AiControllerCoachThreadsData, ThrowOnError>): RequestResult<AiControllerCoachThreadsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<AiControllerCoachThreadsResponses, unknown, ThrowOnError>({ url: '/api/ai/coach-threads', ...options });

/**
 * Neues Gespräch mit dem KI-Coach beginnen
 */
export const aiControllerCreateCoachThread = <ThrowOnError extends boolean = false>(options: Options<AiControllerCreateCoachThreadData, ThrowOnError>): RequestResult<AiControllerCreateCoachThreadResponses, unknown, ThrowOnError> => (options.client ?? client).post<AiControllerCreateCoachThreadResponses, unknown, ThrowOnError>({
    url: '/api/ai/coach-threads',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Eigenes Gespräch mit dem KI-Coach löschen
 */
export const aiControllerDeleteCoachThread = <ThrowOnError extends boolean = false>(options: Options<AiControllerDeleteCoachThreadData, ThrowOnError>): RequestResult<AiControllerDeleteCoachThreadResponses, AiControllerDeleteCoachThreadErrors, ThrowOnError> => (options.client ?? client).delete<AiControllerDeleteCoachThreadResponses, AiControllerDeleteCoachThreadErrors, ThrowOnError>({ url: '/api/ai/coach-threads/{id}', ...options });

/**
 * Ein eigenes Gespräch mit dem KI-Coach
 */
export const aiControllerCoachThreadById = <ThrowOnError extends boolean = false>(options: Options<AiControllerCoachThreadByIdData, ThrowOnError>): RequestResult<AiControllerCoachThreadByIdResponses, AiControllerCoachThreadByIdErrors, ThrowOnError> => (options.client ?? client).get<AiControllerCoachThreadByIdResponses, AiControllerCoachThreadByIdErrors, ThrowOnError>({ url: '/api/ai/coach-threads/{id}', ...options });

/**
 * Eigenen Chatverlauf ändern (Titel, Favorit)
 */
export const aiControllerUpdateCoachThread = <ThrowOnError extends boolean = false>(options: Options<AiControllerUpdateCoachThreadData, ThrowOnError>): RequestResult<AiControllerUpdateCoachThreadResponses, unknown, ThrowOnError> => (options.client ?? client).patch<AiControllerUpdateCoachThreadResponses, unknown, ThrowOnError>({
    url: '/api/ai/coach-threads/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Sprachgespräch mit dem Coach nachmelden
 *
 * Seit dem 12.08.2026 schreibt der Server die Beiträge eines Anrufs selbst, weil die Sprachverbindung über ihn läuft. Diese Route bleibt als Nachmeldeweg bestehen.
 */
export const aiControllerReportThreadVoiceTurns = <ThrowOnError extends boolean = false>(options: Options<AiControllerReportThreadVoiceTurnsData, ThrowOnError>): RequestResult<AiControllerReportThreadVoiceTurnsResponses, AiControllerReportThreadVoiceTurnsErrors, ThrowOnError> => (options.client ?? client).post<AiControllerReportThreadVoiceTurnsResponses, AiControllerReportThreadVoiceTurnsErrors, ThrowOnError>({
    url: '/api/ai/coach-threads/{id}/voice-turns',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Audioaufnahme transkribieren
 */
export const aiControllerTranscribe = <ThrowOnError extends boolean = false>(options?: Options<AiControllerTranscribeData, ThrowOnError>): RequestResult<AiControllerTranscribeResponses, unknown, ThrowOnError> => (options?.client ?? client).post<AiControllerTranscribeResponses, unknown, ThrowOnError>({ url: '/api/ai/transcribe', ...options });

/**
 * Reflexionsgespräch zu einer Phase
 *
 * Stufe, Verlauf und die bisher eingebrachte Selbsteinschätzung. Wird beim ersten Aufruf angelegt.
 */
export const reflectionControllerGet = <ThrowOnError extends boolean = false>(options: Options<ReflectionControllerGetData, ThrowOnError>): RequestResult<ReflectionControllerGetResponses, ReflectionControllerGetErrors, ThrowOnError> => (options.client ?? client).get<ReflectionControllerGetResponses, ReflectionControllerGetErrors, ThrowOnError>({ url: '/api/sessions/{id}/reflection', ...options });

/**
 * Stufe des Reflexionsgesprächs weiterschalten
 *
 * Läuft nie zurück. Die gemeinsame Analyse setzt eine eingebrachte Selbsteinschätzung voraus, es sei denn, die Beraterin fordert sie ausdrücklich an.
 */
export const reflectionControllerAdvance = <ThrowOnError extends boolean = false>(options: Options<ReflectionControllerAdvanceData, ThrowOnError>): RequestResult<ReflectionControllerAdvanceResponses, ReflectionControllerAdvanceErrors, ThrowOnError> => (options.client ?? client).post<ReflectionControllerAdvanceResponses, ReflectionControllerAdvanceErrors, ThrowOnError>({
    url: '/api/sessions/{id}/reflection/advance',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Selbsteinschätzung löschen
 *
 * Entfernt die eigene Einschätzung und behält das Feedback. Die Hoheit über die Coaching-Ergebnisse liegt beim Mitarbeiter.
 */
export const reflectionControllerRemove = <ThrowOnError extends boolean = false>(options: Options<ReflectionControllerRemoveData, ThrowOnError>): RequestResult<ReflectionControllerRemoveResponses, ReflectionControllerRemoveErrors, ThrowOnError> => (options.client ?? client).delete<ReflectionControllerRemoveResponses, ReflectionControllerRemoveErrors, ThrowOnError>({ url: '/api/sessions/{id}/reflection/self-assessment', ...options });

/**
 * Lernentwicklungs-Essenz löschen
 *
 * Entfernt Essenz und erfasste Antworten. Das Kennenlerngespräch bleibt und ist separat löschbar — die Hoheit über beide liegt beim Mitarbeiter.
 */
export const learningEssenceControllerRemove = <ThrowOnError extends boolean = false>(options?: Options<LearningEssenceControllerRemoveData, ThrowOnError>): RequestResult<LearningEssenceControllerRemoveResponses, LearningEssenceControllerRemoveErrors, ThrowOnError> => (options?.client ?? client).delete<LearningEssenceControllerRemoveResponses, LearningEssenceControllerRemoveErrors, ThrowOnError>({ url: '/api/learning-essence', ...options });

/**
 * Eigene Lernentwicklungs-Essenz
 *
 * Status des Kennenlerngesprächs und, nach Abschluss, die daraus abgeleiteten Prioritäten, Stärken und Handlungsfelder. Immer die eigene: es gibt keinen Zugriff auf die Essenz anderer Nutzer.
 */
export const learningEssenceControllerGet = <ThrowOnError extends boolean = false>(options?: Options<LearningEssenceControllerGetData, ThrowOnError>): RequestResult<LearningEssenceControllerGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<LearningEssenceControllerGetResponses, unknown, ThrowOnError>({ url: '/api/learning-essence', ...options });

/**
 * Kennenlerngespräch beginnen oder fortsetzen
 *
 * Legt beim ersten Aufruf das Gespräch mit dem gewählten Coach an, inklusive seiner Eröffnung. Weitere Aufrufe liefern dasselbe Gespräch.
 */
export const learningEssenceControllerStart = <ThrowOnError extends boolean = false>(options?: Options<LearningEssenceControllerStartData, ThrowOnError>): RequestResult<LearningEssenceControllerStartResponses, unknown, ThrowOnError> => (options?.client ?? client).post<LearningEssenceControllerStartResponses, unknown, ThrowOnError>({ url: '/api/learning-essence/start', ...options });

/**
 * Kennenlernen überspringen
 *
 * Merkt das Überspringen; die Startseite erinnert weiter daran. Nach einem Abschluss nicht mehr möglich.
 */
export const learningEssenceControllerSkip = <ThrowOnError extends boolean = false>(options?: Options<LearningEssenceControllerSkipData, ThrowOnError>): RequestResult<LearningEssenceControllerSkipResponses, LearningEssenceControllerSkipErrors, ThrowOnError> => (options?.client ?? client).post<LearningEssenceControllerSkipResponses, LearningEssenceControllerSkipErrors, ThrowOnError>({ url: '/api/learning-essence/skip', ...options });

/**
 * Lernfelder des aktiven Fragenkatalogs
 *
 * Die Lernfelder samt eigenem Fortschritt. Ist noch kein Katalog eingespielt, kommt eine leere Liste ohne Katalogangabe zurück — die Oberfläche zeigt dann einen Hinweis statt einer leeren Seite.
 */
export const pruefungControllerLernfelder = <ThrowOnError extends boolean = false>(options?: Options<PruefungControllerLernfelderData, ThrowOnError>): RequestResult<PruefungControllerLernfelderResponses, unknown, ThrowOnError> => (options?.client ?? client).get<PruefungControllerLernfelderResponses, unknown, ThrowOnError>({ url: '/api/pruefung/lernfelder', ...options });

/**
 * Eigenen Lernstand zurücksetzen
 *
 * Löscht Antworten, Wiedervorlage und Merkzettel. Der Fragenkatalog bleibt unberührt.
 */
export const pruefungControllerZuruecksetzen = <ThrowOnError extends boolean = false>(options?: Options<PruefungControllerZuruecksetzenData, ThrowOnError>): RequestResult<PruefungControllerZuruecksetzenResponses, unknown, ThrowOnError> => (options?.client ?? client).delete<PruefungControllerZuruecksetzenResponses, unknown, ThrowOnError>({ url: '/api/pruefung/lernstand', ...options });

/**
 * Eigener Lernstand
 *
 * Quoten je Lernfeld und die Beobachtungen des Coaches. Immer der eigene: es gibt keinen Zugriff auf den Lernstand anderer Nutzer.
 */
export const pruefungControllerLernstandAbrufen = <ThrowOnError extends boolean = false>(options?: Options<PruefungControllerLernstandAbrufenData, ThrowOnError>): RequestResult<PruefungControllerLernstandAbrufenResponses, unknown, ThrowOnError> => (options?.client ?? client).get<PruefungControllerLernstandAbrufenResponses, unknown, ThrowOnError>({ url: '/api/pruefung/lernstand', ...options });

/**
 * Prüfungstermin setzen oder löschen
 *
 * Der Coach nutzt den Termin, um das Lerntempo einzuordnen.
 */
export const pruefungControllerSetzeTermin = <ThrowOnError extends boolean = false>(options: Options<PruefungControllerSetzeTerminData, ThrowOnError>): RequestResult<PruefungControllerSetzeTerminResponses, unknown, ThrowOnError> => (options.client ?? client).patch<PruefungControllerSetzeTerminResponses, unknown, ThrowOnError>({
    url: '/api/pruefung/lernstand',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Antwort auf eine Prüfungsfrage abgeben
 *
 * Bewertet die Antwort gegen den Katalog und schreibt den Lernstand fort. Bei den Auswahltypen ist die Bewertung rein rechnerisch; nur bei offenen Fragen urteilt ein Modell gegen die hinterlegte Musterantwort. Die Antwort enthält die richtige Lösung und die Begründung aus dem Katalog — beides erst jetzt, nicht schon beim Stellen der Frage.
 */
export const pruefungControllerAntworten = <ThrowOnError extends boolean = false>(options: Options<PruefungControllerAntwortenData, ThrowOnError>): RequestResult<PruefungControllerAntwortenResponses, PruefungControllerAntwortenErrors, ThrowOnError> => (options.client ?? client).post<PruefungControllerAntwortenResponses, PruefungControllerAntwortenErrors, ThrowOnError>({
    url: '/api/pruefung/antworten',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Auswertungen eines Gesprächs
 *
 * Damit beantwortete Fragen nach dem Neuladen im Ergebniszustand stehen statt wieder offen. Nur für eigene Gespräche.
 */
export const pruefungControllerAuswertungen = <ThrowOnError extends boolean = false>(options: Options<PruefungControllerAuswertungenData, ThrowOnError>): RequestResult<PruefungControllerAuswertungenResponses, PruefungControllerAuswertungenErrors, ThrowOnError> => (options.client ?? client).get<PruefungControllerAuswertungenResponses, PruefungControllerAuswertungenErrors, ThrowOnError>({ url: '/api/pruefung/threads/{id}/antworten', ...options });

/**
 * Lernziel eines Gesprächs verlängern
 *
 * Erhöht die Zahl der Fragen, die die Beraterin in diesem Gespräch beantworten will, gerechnet ab dem bisherigen Ziel. Nur für eigene Prüfungsgespräche.
 */
export const pruefungControllerVerlaengereZiel = <ThrowOnError extends boolean = false>(options: Options<PruefungControllerVerlaengereZielData, ThrowOnError>): RequestResult<PruefungControllerVerlaengereZielResponses, PruefungControllerVerlaengereZielErrors, ThrowOnError> => (options.client ?? client).post<PruefungControllerVerlaengereZielResponses, PruefungControllerVerlaengereZielErrors, ThrowOnError>({
    url: '/api/pruefung/threads/{id}/ziel/verlaengern',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Eigene Gesprächstrainings (kompakte Listenform)
 */
export const processRunControllerList = <ThrowOnError extends boolean = false>(options?: Options<ProcessRunControllerListData, ThrowOnError>): RequestResult<ProcessRunControllerListResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ProcessRunControllerListResponses, unknown, ThrowOnError>({ url: '/api/process-runs', ...options });

/**
 * Gesprächstraining starten
 */
export const processRunControllerCreate = <ThrowOnError extends boolean = false>(options: Options<ProcessRunControllerCreateData, ThrowOnError>): RequestResult<ProcessRunControllerCreateResponses, unknown, ThrowOnError> => (options.client ?? client).post<ProcessRunControllerCreateResponses, unknown, ThrowOnError>({
    url: '/api/process-runs',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Ein eigenes Gesprächstraining
 */
export const processRunControllerGet = <ThrowOnError extends boolean = false>(options: Options<ProcessRunControllerGetData, ThrowOnError>): RequestResult<ProcessRunControllerGetResponses, ProcessRunControllerGetErrors, ThrowOnError> => (options.client ?? client).get<ProcessRunControllerGetResponses, ProcessRunControllerGetErrors, ThrowOnError>({ url: '/api/process-runs/{id}', ...options });

/**
 * Aktuelle Phase abschließen und zur nächsten wechseln
 */
export const processRunControllerAdvance = <ThrowOnError extends boolean = false>(options: Options<ProcessRunControllerAdvanceData, ThrowOnError>): RequestResult<ProcessRunControllerAdvanceResponses, unknown, ThrowOnError> => (options.client ?? client).post<ProcessRunControllerAdvanceResponses, unknown, ThrowOnError>({ url: '/api/process-runs/{id}/advance', ...options });

/**
 * Gesprächsvorbereitung abschließen
 */
export const processRunControllerPreparation = <ThrowOnError extends boolean = false>(options: Options<ProcessRunControllerPreparationData, ThrowOnError>): RequestResult<ProcessRunControllerPreparationResponses, unknown, ThrowOnError> => (options.client ?? client).post<ProcessRunControllerPreparationResponses, unknown, ThrowOnError>({
    url: '/api/process-runs/{id}/preparation',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Nacharbeit abschließen und das Gesamtbild freigeben
 *
 * Schließt das Sparring der Nachbereitung ab und hält die Antworten auf die Leitfragen fest. Der Durchlauf bleibt in dieser Einheit — beendet wird er über /advance, wenn der Bericht gelesen ist.
 */
export const processRunControllerNachbereitung = <ThrowOnError extends boolean = false>(options: Options<ProcessRunControllerNachbereitungData, ThrowOnError>): RequestResult<ProcessRunControllerNachbereitungResponses, unknown, ThrowOnError> => (options.client ?? client).post<ProcessRunControllerNachbereitungResponses, unknown, ThrowOnError>({
    url: '/api/process-runs/{id}/nachbereitung',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Stand des AV-Tools festhalten
 *
 * Speichert die Eingaben des Beratungswerkzeugs im Fallzustand und rechnet das Ergebnis serverseitig neu. Mit `zeigen` wird die Versorgungslücke zusätzlich in den Fallzustand übernommen — erst dadurch kennt der KI-Kunde die Zahl. Der Durchlauf bleibt in der Einheit; abgeschlossen wird sie wie bisher über /advance.
 */
export const processRunControllerAvTool = <ThrowOnError extends boolean = false>(options: Options<ProcessRunControllerAvToolData, ThrowOnError>): RequestResult<ProcessRunControllerAvToolResponses, unknown, ThrowOnError> => (options.client ?? client).post<ProcessRunControllerAvToolResponses, unknown, ThrowOnError>({
    url: '/api/process-runs/{id}/av-tool',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Lösungsvorschlag festhalten
 *
 * Speichert die Produktauswahl aus „Lösung & Abschluss“ im Fallzustand. Mit `zeigen` dreht die Beraterin den Bildschirm zum Kunden: der Server baut daraus die Handlungszeile, auf die der KI-Kunde reagiert, auch im laufenden Sprachgespräch. Nur in dieser Einheit erlaubt.
 */
export const processRunControllerLoesung = <ThrowOnError extends boolean = false>(options: Options<ProcessRunControllerLoesungData, ThrowOnError>): RequestResult<ProcessRunControllerLoesungResponses, unknown, ThrowOnError> => (options.client ?? client).post<ProcessRunControllerLoesungResponses, unknown, ThrowOnError>({
    url: '/api/process-runs/{id}/loesung',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Gesamt-Debrief über alle IVFP-Phasen
 */
export const processRunControllerDebrief = <ThrowOnError extends boolean = false>(options: Options<ProcessRunControllerDebriefData, ThrowOnError>): RequestResult<ProcessRunControllerDebriefResponses, unknown, ThrowOnError> => (options.client ?? client).get<ProcessRunControllerDebriefResponses, unknown, ThrowOnError>({ url: '/api/process-runs/{id}/debrief', ...options });

/**
 * Sprachgespräch mit dem Durchlauf-Coach nachmelden
 *
 * Ohne diese Meldung existiert der Anruf weder im Coach-Verlauf des Durchlaufs noch in der Kostenrechnung.
 */
export const processRunControllerReportVoiceTurns = <ThrowOnError extends boolean = false>(options: Options<ProcessRunControllerReportVoiceTurnsData, ThrowOnError>): RequestResult<ProcessRunControllerReportVoiceTurnsResponses, unknown, ThrowOnError> => (options.client ?? client).post<ProcessRunControllerReportVoiceTurnsResponses, unknown, ThrowOnError>({
    url: '/api/process-runs/{id}/voice-turns',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Kennzahlen des Mandanten
 *
 * Ausschliesslich Aggregate: Nutzung, IDD-Zeit, Akzeptanz und Kosten. Einzelne Gespräche sind hier bewusst nicht enthalten.
 */
export const analyticsControllerOverview = <ThrowOnError extends boolean = false>(options?: Options<AnalyticsControllerOverviewData, ThrowOnError>): RequestResult<AnalyticsControllerOverviewResponses, AnalyticsControllerOverviewErrors, ThrowOnError> => (options?.client ?? client).get<AnalyticsControllerOverviewResponses, AnalyticsControllerOverviewErrors, ThrowOnError>({ url: '/api/analytics/overview', ...options });

/**
 * Trainings je Tag
 */
export const analyticsControllerTrainingsPerDay = <ThrowOnError extends boolean = false>(options?: Options<AnalyticsControllerTrainingsPerDayData, ThrowOnError>): RequestResult<AnalyticsControllerTrainingsPerDayResponses, unknown, ThrowOnError> => (options?.client ?? client).get<AnalyticsControllerTrainingsPerDayResponses, unknown, ThrowOnError>({ url: '/api/analytics/trainings-per-day', ...options });

/**
 * Durchschnitt je Feedback-Dimension
 */
export const analyticsControllerDimensions = <ThrowOnError extends boolean = false>(options?: Options<AnalyticsControllerDimensionsData, ThrowOnError>): RequestResult<AnalyticsControllerDimensionsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<AnalyticsControllerDimensionsResponses, unknown, ThrowOnError>({ url: '/api/analytics/dimensions', ...options });
